import { render, staticRenderFns } from "./paybilldiscounts.vue?vue&type=template&id=3407cd22&scoped=true&"
import script from "./paybilldiscounts.vue?vue&type=script&lang=js&"
export * from "./paybilldiscounts.vue?vue&type=script&lang=js&"
import style0 from "./paybilldiscounts.vue?vue&type=style&index=0&id=3407cd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3407cd22",
  null
  
)

export default component.exports